import React, { useEffect, useState } from 'react';
import { Button, Text } from '@mantine/core';
import { IconHistory } from '@tabler/icons-react';
import type { ICambioVariable } from '../../../modelos/CotizadorNBS';
import { ModalHistorialCambiosVista } from '../vista/modalHistorialCambiosVista';
import { useAvisoErrorConsulta } from './useAvisoErrorConsulta';

interface HistorialCambiosVariablesCVProps {
    /** Consulta los cambios (configuración global del país o de una cotización). */
    cargar: () => Promise<ICambioVariable[]>;
    /** Qué historial es, debajo del título y en los avisos (p. ej. "Configuración global"). */
    subtitulo: string;
    /** Moneda de los viáticos (COP en Colombia, USD en países en dólares). */
    monedaLocal: string;
}

/**
 * Botón "Historial de Cambios" (con texto: un ícono solo se pierde) y su modal: quién cambió qué variable,
 * cuándo, y el valor antes y después (lo registra el back en cada guardado). Se consulta al abrir.
 */
export const HistorialCambiosVariablesCV: React.FC<HistorialCambiosVariablesCVProps> = ({ cargar, subtitulo, monedaLocal }) => {
    const [abierto, setAbierto] = useState(false);
    const [cambios, setCambios] = useState<ICambioVariable[] | null>(null);
    const avisarErrorConsulta = useAvisoErrorConsulta();

    useEffect(() => {
        if (!abierto) return;
        let vigente = true;
        setCambios(null);
        cargar()
            .then(datos => { if (vigente) setCambios(datos); })
            .catch(error => {
                avisarErrorConsulta(error, `el historial de cambios (${subtitulo})`);
                if (vigente) setCambios([]);
            });
        return () => { vigente = false; };
        // cargar cambia en cada render del padre: solo se consulta al abrir.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [abierto]);

    return (
        <>
            <Button color="primary" variant="light" size="xs" radius="lg" leftSection={<IconHistory size={14} />} onClick={() => setAbierto(true)}>
                <Text fw={500} size="xs">Historial de Cambios</Text>
            </Button>
            <ModalHistorialCambiosVista
                abierto={abierto}
                alCerrar={() => setAbierto(false)}
                cambios={cambios}
                subtitulo={subtitulo}
                monedaLocal={monedaLocal}
            />
        </>
    );
};
